import React, { useEffect, useState } from "react";
import Icon from "../../_default/Icon";
import Input from "../../_default/Input";
import exercise from "../../../assets/images/exercise.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ExerciseDetails from "./ExerciseDetails";
import "./Superset.scss";

export default function Exercise({ setSetOfFirst, setOfFirst, previousValues, isPersonal, isAdmin, set_idx, exercises, item, idx, removeExercise, onChange, addSubs }) {

  useEffect(() => {
    if(idx > 0) {
      onChange(setOfFirst, "sets", idx);
    }

  }, [setOfFirst])

  return (
    <Draggable draggableId={item.exercise_id} key={item.exercise_id} index={idx}>
      {(provided, snapshot) => (
        <div className={`c-set-item c-set-exercise ${snapshot.isDragging ? "--ondrag" : ""}`} isDragging={snapshot.isDragging} ref={provided.innerRef} {...provided.draggableProps}>
          <div className="c-set-exercise-content">
            <div
              className="c-set-exercise-image"
              style={{
                backgroundImage: `url('${item.image}')`,
              }}
            />
            <h3>{item.name}</h3>

            {/* {isAdmin ? (
              <Input label="Subsitute Excercise(s)" type="multi" tags={item.subsitute} options={exercises} onRemove={(e) => onChange(e, "subsitute_remove", idx)} onSelect={(e) => onChange(e, "subsitute_add", idx)} />
            ) : (
              <div className="c-coach-pills-wrapper">
                <span>Subsitute Excercise(s)</span>
                <ul className="c-coach-pills">
                  {item.subsitute.map((tag, idx) => (
                    <li key={idx}>{tag.name}</li>
                  ))}
                </ul>
              </div>
            )} */}
            <div className="c-set-reps">
              <label className="switch" style={{ top: 8, right: 50 }}>
                <span style={{  position: 'absolute', top: 5, width: 110, right: 70, fontSize: 19, fontWeight: 600, textTransform: 'none' }}>Switch sides</span>
                <input type="checkbox" checked={item.switch_sides} onChange={(e) => { console.log(e, idx); onChange(e.target.checked, "switch_sides", idx)} } name="Back" />
                <span className="slider round"></span>
              </label>
              <div>
                <ExerciseDetails setOfFirst={setOfFirst} addSubs={addSubs} setSetOfFirst={setSetOfFirst} subexercise={false} setIdx={set_idx} previousValues={previousValues} isPersonal={isPersonal} isAdmin={isAdmin} exercises={exercises} item={item} idx={idx} removeExercise={(idx) => removeExercise(idx, set_idx)} onChange={(e, type, exercise_idx) => onChange(e, type, exercise_idx, set_idx, undefined, false)} />
                
                
                <Droppable droppableId={item.id} type="child">
            {(provided) => (
              <div className="c-set-exercises" ref={provided.innerRef} {...provided.droppableProps}>
                { 
                // console.log(item.subexercises) && 
                item.subexercises && (
                  item.subexercises.map((subitem, subIdx) => (
                    <ExerciseDetails key={subIdx} setOfFirst={setOfFirst} addSubs={addSubs} setSetOfFirst={setSetOfFirst} subexercise={true} setIdx={set_idx} previousValues={previousValues} isPersonal={isPersonal} isAdmin={isAdmin} exercises={exercises} item={subitem} idx={subIdx} exIdx={idx} removeExercise={(idx) => removeExercise(idx, set_idx)} onChange={(e, type) => onChange(e, type, idx, set_idx, subIdx, true)} />
                  )))
                }
                {provided.placeholder}
              </div>
            )}
          </Droppable>


              </div>
              
              {/* item.sets > 1 && <div onClick={() => addSubs(item.sets - 1)} className="btn-add"></div> */}
            </div>
          </div>
          {isAdmin && (
            <div className="workout-set-icons">
              <div className="c-move-icon" {...provided.dragHandleProps}>
                <Icon icon="move" />
              </div>
              <div className="c-trash-icon" {...provided.dragHandleProps} onClick={(e) => {previousValues(e)}}>
                {/*<Icon icon="agenda" stroke="#000" size={16}/>*/}
              </div>
              <div className="c-trash-icon" onClick={() => removeExercise(idx)}>
                <Icon icon="trash" size={16}/>
              </div>
            </div>
          )}
        </div>
      )}
    </Draggable>
  );
}
